<template>
  <div class="notiMess">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"

    >
      <ul>
    <li class="listLi" v-for="(item, index) of listData" :key="index" @click="msgFn(item)">
      <div class="titleBox">
        <b>{{item.title}}</b>
        <span>{{item.time}}&nbsp;<i v-if="item.ifMess"></i></span>
      </div>
      <div class="contentBox">
        <p>{{item.content.length > 35 ? item.content.substr(0, 35) + '...' : item.content}}</p>
        <img v-if="item.url" src="../../assets/images/jt2.png">
      </div>
    </li>
  </ul>
    </Scroller>
    <!--<p><span>————</span>&nbsp;&nbsp;客官，木有啦~&nbsp;&nbsp;<span>————</span></p>-->
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'noticeMessage',
  data () {
    return {
      listData: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——'
    }
  },
  components: {
    Scroller
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'noticemessage'})
    }
    // this.nowPage = 1
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/') { // 当前页面刷新不需要切换位置
      next(vm => {
        vm.nowPage = 0
      })
    } else {
      next(vm => {
        if (from.path == '/messagecenter') Object.assign(vm.$data, vm.$options.data())
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) {//记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path == '/messagecenter') this.loading = true
    next()
  },
  methods: {
    getData () {
      var url = this.$ajax.getNoticeMessageList_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var that = this
      that.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.listData = res.data.list
            that.refresh = false
          } else {
            that.listData = that.listData.concat(res.data.list)
          }
          that.loading = false
          if (res.data.list.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      var that = this
      that.getData()
      // this.editorClick()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    msgFn (items) {
      var that = this
      if (items.url) {
        window.location.href = items.url
      } else {
        that.$dialog({
          title: items.title,
          message: items.content,
          className: 'percen_button_alert',
          confirmButtonText: '确定'
        }).then(() => {
          // on confirm
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">

.notiMess {
  >p {
    font-size:0.12rem;
    font-weight:400;
    color:rgba(153,153,153,1);
    text-align: center;
    padding:0.3rem 0 0.33rem;
    span{
      color:rgba(221,221,221,1);
    }
  }
  .listLi {
    /*height: 0.91rem;*/
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    -moz-flex-direction: column;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    -moz-justify-content: space-between;
    padding: 0.11rem 0.14rem 0.14rem 0.11rem;
    background: #fff;
    margin: 0.1rem 0.11rem 0;
    border-radius: 0.04rem;
    &:last-of-type{
      margin-bottom: 0.1rem;
    }
    .titleBox {
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      -moz-justify-content: space-between;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      margin-bottom: 0.09rem;
      b {
        color: #222222;
        font-size: 0.15rem;
        display: block;
        font-weight:600;
        flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        -o-flex: 1;
        overflow: hidden;
        /* visibility: collapse; */
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        color: #999999;
        font-size: 0.11rem;
        display: flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        -moz-align-items: center;
        i {
          display: block;
          width:0.05rem;
          height:0.05rem;
          border-radius: 50%;
          background: #FC0324;
        }
      }
    }
    .contentBox {
      height: 0.36rem;
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      -moz-justify-content: space-between;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      p {
        color: #444444;
        font-size: 0.13rem;
        display: block;
        margin-right: 0.16rem;
      }
      img {
        width: 0.06rem;
        height: 0.11rem;
        display: block;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/message/noticeMessage.vue